"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_3g(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 191.5"
  }, props), /*#__PURE__*/React.createElement("title", null, "3g-hi"), /*#__PURE__*/React.createElement("g", {
    id: "653c4ce7-c9aa-4374-aa28-ca391841f5a4",
    "data-name": "3g-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1aa4fc27-95b8-4e27-a550-98b1c1d257d0",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a6cc092b-af35-4d28-8e7a-15fa92688add",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5cefd6c8-be55-45a0-9140-c278dc03066a",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c0bdb065-7b96-431c-a931-77eda45fcde5",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "64299684-64a2-4432-9604-8d0807c8f083",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fa7be4b0-9949-470c-b1de-f55b761e8968",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e8cd5570-9d4a-45a2-8e13-4bc49720a7cb",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ba0b5945-bebf-4d9c-b611-2541403b06db",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7df98672-3b83-4558-8b02-68e68160b153",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00686839-f85b-4a6e-b632-c0598f6cda50",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c50864c4-f636-450d-809a-8b540e51feab",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c6451b18-fcb8-4ebb-a293-ff71498d5b29",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5cde0333-75f6-4d1b-921e-e6d9a7ef509b",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ade6bd0a-2d68-4627-afd0-61721f29525c",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b5d7107e-fa10-41c8-b930-9eaaa8a46523",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "81a913e2-1e1f-4867-b1f0-441bcde73b98",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1bf44f14-14e1-4444-99ba-3210694a57f9",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2ceb1187-4e00-42bf-a99d-f4b9ca706a1d",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5c2ae88b-e616-46db-a08e-2f703e986cdc",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ad7fa642-e815-4d30-8391-fc3aee2cbba8",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "70852e13-d4bb-4415-872f-234cc2e03cb0",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7e0ab1c8-7ea9-47b3-a85f-e7d5241cacd3",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d66855d7-66c6-4060-be80-e49c70d92c20",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6c84652e-aca1-431c-b600-c8f40cf93a26",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6b285c5b-8c55-41de-9413-b2fe2ae73970",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "be689dbd-e975-483c-8314-dfaca3352807",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5b54e146-e263-4d95-b0f1-c4c135e3d275",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.25a80,80,0,0,1-80-79c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174.25Z",
    transform: "translate(0 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 191.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.35,127.84a33.35,33.35,0,0,1-12.19-2.06,30.44,30.44,0,0,1-9-5.33l5.38-10.08a30.29,30.29,0,0,0,7.25,4.8,19.51,19.51,0,0,0,8.4,1.82,13.28,13.28,0,0,0,6.34-1.34,8.25,8.25,0,0,0,3.65-3.74,11.83,11.83,0,0,0,1.15-5.18q0-5.76-3.7-8.21t-9.84-2.45a38.79,38.79,0,0,0-5.47.38V88.58a40.31,40.31,0,0,1,3.26-5,67.74,67.74,0,0,1,4.66-5.33q2.93-3.07,4.94-4.8H46.67V62.47h40V73.12A76.17,76.17,0,0,0,80,78.07a59.45,59.45,0,0,0-5.47,5,28.65,28.65,0,0,0-3.31,4.13,20.26,20.26,0,0,1,10.22,2.5,14.51,14.51,0,0,1,6.29,6.86,23.49,23.49,0,0,1,1.92,9.55,22.38,22.38,0,0,1-1.87,9.5,19.86,19.86,0,0,1-5,6.77,20.82,20.82,0,0,1-7.39,4.08A29.62,29.62,0,0,1,66.35,127.84Z",
    transform: "translate(0 -0.25)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.39,127.84a29.21,29.21,0,0,1-11.47-2.21,24.38,24.38,0,0,1-9-6.48,30.14,30.14,0,0,1-5.81-10.42,43.9,43.9,0,0,1-2.06-14A45.12,45.12,0,0,1,99.28,79.8a30.7,30.7,0,0,1,6-10.46,23.69,23.69,0,0,1,8.59-6.19,26.36,26.36,0,0,1,10.22-2q8.26,0,13.54,3.12a21.05,21.05,0,0,1,8,8L137.1,80A15.89,15.89,0,0,0,134,76.15a13.66,13.66,0,0,0-4.51-2.69,15.23,15.23,0,0,0-5.38-1,11.87,11.87,0,0,0-8,3.07,17,17,0,0,0-5.09,8.3,38.47,38.47,0,0,0-1.54,10.9,29.21,29.21,0,0,0,2.59,12.72q2.59,5.42,6.43,7.2a17.74,17.74,0,0,0,7.49,1.78,35.62,35.62,0,0,0,6.19-.43,16.91,16.91,0,0,0,2.74-.62V103.84H125v-11h21.5v30.82a27.76,27.76,0,0,1-7.87,2.88A56.34,56.34,0,0,1,125.39,127.84Z",
    transform: "translate(0 -0.25)",
    fill: "#e60000"
  }))))))))))))))))))))))))))))));
}

var _default = ic_3g;
exports.default = _default;